import { motion } from 'framer-motion';
import { useLang } from '@/context/LanguageContext';

const team = [
  { name: 'Lucas', role: { fr: 'Fondateur RHR', en: 'Founder RHR' } },
  { name: 'Marwan', role: { fr: 'Booking artiste', en: 'Artist Booking' } },
  { name: 'Hugo', role: { fr: 'Ingénieur du son', en: 'Sound Engineer' } },
  { name: 'Nathan', role: { fr: 'Assistant son & accueil artiste', en: 'Sound Assistant & Artist Welcome' } },
  { name: 'Myriam', role: { fr: 'Chef à domicile', en: 'Private Chef' } },
  { name: 'Justine', role: { fr: 'Intendante de la maison', en: 'House Manager' } },
];

const TeamSection = () => {
  const { lang, t } = useLang();

  return (
    <section data-testid="team-section" className="py-24 md:py-32 bg-[#3D2020]">
      <div className="px-5 md:px-10 lg:px-14 max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl mb-20"
        >
          <p className="text-[11px] uppercase tracking-[0.3em] text-white/50 mb-4">
            {t('team.label')}
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white leading-tight mb-5">
            {t('team.title')}
          </h2>
          <p className="text-base text-white/70 leading-relaxed">
            {t('team.desc')}
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-x-12 gap-y-16 md:gap-y-20">
          {team.map((member, i) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              data-testid={`team-member-${member.name.toLowerCase()}`}
            >
              <h3 className="font-heading font-bold text-xl text-white mb-1">
                {member.name}
              </h3>
              <p className="text-sm text-white/60">
                {member.role[lang]}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
